import { defineMessages } from 'react-intl-next';

export const navigationBlockerDefaultMessages = defineMessages({
	navigationBlockModalTitle: {
		defaultMessage: 'Your changes won’t be saved',
		description: 'Title of modal shown when user is about to navigate away from the page',
		id: 'routing-utils.ui.navigation-blocker.navigation-block-modal-title',
	},
	navigationBlockModalBody: {
		defaultMessage: 'We won’t be able to save your data if you move away from this page',
		description: 'Body of modal shown when user is about to navigate away from the page',
		id: 'routing-utils.ui.navigation-blocker.navigation-block-modal-body',
	},
	navigationBlockGoBackButton: {
		defaultMessage: 'Go back',
		description: 'Text in button that will cancel the attempt at navigating away',
		id: 'routing-utils.ui.navigation-blocker.navigation-block-go-back-button',
	},
	navigationBlockContinueButton: {
		defaultMessage: 'Discard',
		description:
			'Text in button that will discard the unsaved changes and continue navigating away',
		id: 'routing-utils.ui.navigation-blocker.navigation-block-continue-button',
	},
});
